import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum CompanyTaxDetailsFormErrorStatesEnum {
    UpdateTaxDetailsFailed = ErrorStateScheduleEnum.CompanyTaxDetailsFormStatesStartIndex,
    TaxDetailsRegistrationFailed,
    TaxWithVatInfoUpdateFailed
}
